import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Static SEO defaults in index.html exist for non-JS crawlers (link scrapers).
// Drop them before mount so react-helmet-async owns the per-page tags.
document.head.querySelectorAll('[data-rh="true"]').forEach((el) => el.remove());

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
